import { useAktion } from "@/lib/useAktion";

/**
 * Kleiner Aktions-Chip im Hero-Bereich. Wird nur eingeblendet wenn
 * `useAktion().active === true`. Editorial: Gold-Pill mit dezenter
 * Uppercase-Typografie.
 */
export default function AktionHeroChip() {
    const aktion = useAktion();
    if (!aktion.active) return null;
    return (
        <div
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full"
            style={{
                background: "hsl(var(--hf-gold-soft) / 0.6)",
                border: "1px solid #A78150",
                color: "#1D1B18",
                letterSpacing: "0.16em",
                fontSize: 10,
                textTransform: "uppercase",
                fontWeight: 600,
            }}
            data-testid="aktion-hero-chip"
        >
            <span
                aria-hidden
                style={{ width: 6, height: 6, background: "#A78150", borderRadius: 999, display: "inline-block" }}
            />
            {aktion.hero_chip_text}
        </div>
    );
}
